import { Outlet } from 'react-router-dom'
import TopBar from '@/src/components/layout/top-bar/TopBar'
import { useState } from 'react'

const Layout = () => {
  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')
  return (
    <div className="h-dvh flex flex-col bg-primary-blue">
      <TopBar variant="dark" title={title} subtitle={subTitle} />
      <div className="flex-1">
        <Outlet context={{ setTitle, setSubTitle }} />
      </div>
    </div>
  )
}

export default Layout
